import { render, staticRenderFns } from "./create-order.vue?vue&type=template&id=996c8c4c&scoped=true"
import script from "./create-order.vue?vue&type=script&lang=js"
export * from "./create-order.vue?vue&type=script&lang=js"
import style0 from "./create-order.vue?vue&type=style&index=0&id=996c8c4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996c8c4c",
  null
  
)

export default component.exports